import { render, staticRenderFns } from "./TableDataSourceCell.vue?vue&type=template&id=5304fb22&scoped=true"
import script from "./TableDataSourceCell.vue?vue&type=script&lang=js"
export * from "./TableDataSourceCell.vue?vue&type=script&lang=js"
import style0 from "./TableDataSourceCell.vue?vue&type=style&index=0&id=5304fb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304fb22",
  null
  
)

export default component.exports